// HideHint
// Features:
// - Displays hint about toggling UI visibility with 'H'
// - Handles 'H' keypress listener for toggling hints
// - Visible only in cabin when UI is enabled

import { useEffect } from 'react'
import { usePhase, PHASES } from '../../../store/usePhase'
import { useStore } from '../../../store/useStore'
import './hint.css'

export default function HideHint() {
    const phase = usePhase((state) => state.phase)
    const toggleHintsHidden = useStore((state) => state.toggleHintsHidden)
    const uiOn = useStore((state) => state.uiOn)

    const isActive = uiOn && phase === PHASES.inCabin

    // Listen for 'H' key to toggle hints
    useEffect(() => {
        if (!isActive) return

        const onKeyDown = (e) => {
            if (e.code === 'KeyH') {
                toggleHintsHidden()
            }
        }
        window.addEventListener('keydown', onKeyDown)
        return () => window.removeEventListener('keydown', onKeyDown)
    }, [isActive, toggleHintsHidden])

    if (!isActive) return null

    return (
        <div className="hide-hint">
            <div className="hide-hint__box">
                <div className="hide-hint__line">H — Hide/Unhide hints</div>
            </div>
        </div>
    )
}
